import React from 'react';
import { Modal, View } from 'react-native';
import { useT } from '@transifex/react';

import { BloomButton } from '../components/BloomButton';
import ThemedText from '../components/ThemedText';
import { cn } from '../utils/cn';
import { screenTestId } from '../utils/testId';

import { featureLabelFor } from './featureLabel';
import type { BiometricType } from './useBiometricCapabilities';

type Props = {
  visible: boolean;
  biometricType: BiometricType;
  onEnable: () => void;
  onDecline: () => void;
};

const tid = screenTestId('BiometricEnroll');

export const BiometricEnrollmentModal: React.FC<Props> = (props) => {
  const { visible, biometricType, onEnable, onDecline } = props;
  const t = useT();
  const featureLabel = featureLabelFor(t, biometricType);

  return (
    <Modal
      visible={visible}
      transparent
      animationType='fade'
      onRequestClose={onDecline}
      testID={tid('modal')}
    >
      <View className='flex-1 bg-black/50 items-center justify-center p-4'>
        <View
          className={cn('w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl')}
          testID={tid('card')}
        >
          <ThemedText type='titleDefault' className='mb-3'>
            {t('Enable {feature}?', { feature: featureLabel })}
          </ThemedText>

          <ThemedText type='bodyRegular' className='mb-6 text-login-gray-70'>
            {t(
              'Sign in to Vida faster next time using {feature} instead of your password. You can change this any time in Settings.',
              { feature: featureLabel }
            )}
          </ThemedText>

          <View className='gap-3'>
            <BloomButton
              onPress={onEnable}
              testID={tid('enable-button')}
              text={t('Enable {feature}', { feature: featureLabel })}
            />
            <BloomButton
              hierarchy='secondary'
              onPress={onDecline}
              testID={tid('decline-button')}
              text={t('Not now')}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};
